'use client';

export function ClientCookieButton() {
  return (
    <button
      type="button"
      onClick={() => {
        if (typeof window !== 'undefined' && (window as any).silktideConsentManager) {
          const instance = (window as any).silktideConsentManager.getInstance();
          if (instance) {
            instance.toggleModal(true);
          } else {
            alert('Consent manager instance is not ready. Please try again.');
          }
        } else {
          alert(
            'Consent manager is loading or not available. Please try again or use the icon in the bottom left corner.'
          );
        }
      }}
      className="bg-primary text-on-primary w-full rounded-xl px-6 py-3 text-sm font-semibold shadow-sm transition hover:opacity-90 sm:w-auto"
    >
      Open Preference Center
    </button>
  );
}
